const nzh = require("nzh/cn");

export const getManagerLevels = _ => {
  let managerLevels = [];
  for (let i = 2; i < 21; i++) {
    managerLevels.push({
      name: `第${nzh.encodeS(i)}级主管`,
      code: i.toString()
    });
  }
  managerLevels.push({
    name: "BOSS",
    code: "0"
  });
  managerLevels.unshift({
    name: "直接主管",
    code: "1"
  });
  return managerLevels;
};

export const getMaxManagerLevels = managerLevel => {
  if (managerLevel === "0" || managerLevel === "20") return [];

  const levels = 20 - parseInt(managerLevel);

  let maxManagerLevels = [];

  for (let i = 1; i <= levels; i++) {
    maxManagerLevels.push({
      name: `向上查找${nzh.encodeS(i)}级`,
      code: i.toString()
    });
  }
  return maxManagerLevels;
};
